var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.disabled)?_c('div',{ref:"jsoneditor",staticClass:"jsoneditor-vue"}):_c('div',[_c('el-input',{attrs:{"type":"textarea","value":_vm.value,"placeholder":_vm.placeholder,"disabled":true,"rows":4}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }